<div class="modal-header">
  <span>{{ modalHeader }}</span>
  <button
    class="close"
    aria-label="Close"
    (click)="closeModal()"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div
  *ngIf="!modalHtmlContent"
  class="modal-body"
>
  {{ modalContent }}
</div>
<div class="modal-body">
  <div
    *ngIf="modalHtmlContent"
    [innerHTML]="modalHtmlContent"
  >
  </div>
  <div>
    <button
      nbButton
      status="primary"
      (click)="doSubmit()"
    >{{modalOkText}}</button>
  </div>

  <div
    *ngIf="modalForceDesc"
    class="mt-4"
  >
    {{modalForceDesc}}
  </div>
  <div *ngIf="modalForceButton" class="mt-2" >
    <button
      nbButton
      status="danger"
      (click)="doForce()"
    >{{modalForceButton}}</button>
  </div>

</div>
<div class="modal-footer">

  <button
    *ngIf="modalCancelEnabled"
    nbButton
    outline
    (click)="doCancel()"
  >{{modalCancelText}}</button>
</div>
